import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);
gsap.defaults({
  duration: 0.4,
  ease: 'power2.inOut',
});

class InPageNav {
  constructor() {
    this.nav = document.querySelector('.js-page-nav');
    this.selects = document.querySelectorAll('.js-set-active');
    this.isMobile = true;

    if (this.nav) {
      this.init();
      this.bindEvents();
    }
  }

  init() {
    const checkExists = setInterval(() => {
      if (this.nav.children.length) {
        this.trackScroll();
        if ((this.nav = document.querySelector('.program-content__nav.js-page-nav'))) {
          this.backToTop();
        }
        clearInterval(checkExists);
      }
    }, 100);
  }

  bindEvents() {
    this.links = Array.from(this.nav.querySelectorAll('a'));
    this.links.forEach(link => {
      link.addEventListener('click', this.handleClick.bind(this));
    });
    window.addEventListener('popstate', () => {
      history.replaceState({}, '', `${window.location.href.split('#')[0]}`);
    });
  }

  handleClick(e) {
    const navItem = e.target.parentElement;
    navItem.classList.add('nav-item--active');
  }

  trackScroll() {
    const links = Array.from(this.nav.querySelectorAll('a'));
    links.forEach(link => {
      const hash = link.hash.substr(1);
      const section = document.getElementById(hash);

      const enter = () => {
        if (section) {
          if (hash === section.id) {
            link.parentElement.classList.add('nav-item--active');

            if (window.history.pushState) {
              window.history.pushState(null, null, `#${hash}`);
            } else {
              window.location.hash = `#${hash}`;
            }
          }
        }
      };

      const leave = () => {
        if ((this.nav = document.querySelector('.program-content__nav .js-page-nav'))) {
          this.backToTop();
        }
      };

      const leaveBack = () => {
        if (hash === section.id) {
          link.parentElement.classList.remove('nav-item--active');
        }
      };

      gsap.set(section, {
        scrollTrigger: {
          trigger: section,
          start: 'top 100px',
          end: '75% 0px',
          onEnter: enter,
          onEnterBack: enter,
          onLeave: leave,
          onLeaveBack: leaveBack,
        },
      });
    });
  }

  backToTop() {
    const backToTopButton = document.getElementById('js-nav-back-to-top-cta');

    backToTopButton.addEventListener('click', () =>
      document.documentElement.scrollTo({
        top: 0,
        behavior: 'smooth',
      }),
    );
  }

  handleNavBar() {
    ScrollTrigger.matchMedia({
      // Desktop
      '(min-width: 1200px)': () => {
        gsap.set('.js-page-nav', { opacity: 0, pointerEvents: 'none', yPercent: 0 });

        gsap.to('.js-page-nav', {
          scrollTrigger: {
            trigger: '.main#content',
            toggleActions: 'play reverse play reverse',
            start: 'top 75px',
            end: 'bottom 85%',
          },
          yPercent: 0,
        });

        const enter = () => gsap.set('.js-page-nav', { opacity: 1, pointerEvents: 'initial' });
        const leave = () =>
          gsap.set('.js-page-nav', { opacity: 0, pointerEvents: 'none', delay: 0.4 });

        gsap.to('.js-page-nav', {
          scrollTrigger: {
            trigger: 'main#content',
            toggleActions: 'play none play none',
            onEnter: enter,
            onEnterBack: enter,
            onLeave: leave,
            onLeaveBack: leave,
            start: 'top 75px',
            end: 'bottom 85%',
          },
        });
      },

      // Small screens
      '(max-width: 1070px)': () => {
        gsap.set(['.js-page-nav', '.main#content'], {
          clearProps: 'all',
        });
      },
    });
  }
}

export default InPageNav;
